import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal,
  WritableSignal
} from '@angular/core';
import { GiftCardPreviewComponent } from '../../components/gift-card-preview/gift-card-preview.component';
import {
  InputComponent,
  InputStyle
} from '../../../../shared/components/controllers/input/input.component';
import {
  TextareaComponent,
  TextareaStyle
} from '../../../../shared/components/controllers/textarea/textarea.component';
import {
  CounterComponent,
  CounterStyle
} from '../../../../shared/components/controllers/counter/counter.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicValidationDependencies } from '../../../../shared/components/controllers/control-error/validation-error-messages.token';
import { GalleryComponent } from '../../../../shared/components/controllers/gallery/gallery.component';
import { createFileByPath } from '../../../../shared/utils/file.util';
import { AmountSelectorComponent } from '../../../../shared/components/controllers/amount-selector/amount-selector.component';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-gift-card-create-page',
  imports: [
    GiftCardPreviewComponent,
    InputComponent,
    TextareaComponent,
    CounterComponent,
    ButtonComponent,
    ...DynamicValidationDependencies,
    GalleryComponent,
    AmountSelectorComponent,
    CurrencyPipe
  ],
  templateUrl: './gift-card-create-page.component.html',
  styleUrl: './gift-card-create-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftCardCreatePageComponent implements OnInit {
  protected readonly InputStyle = InputStyle;
  protected readonly TextareaStyle = TextareaStyle;
  protected readonly CounterStyle = CounterStyle;
  protected readonly AMOUNT_OPTIONS = [25, 50, 100, 200, 500];

  giftCardForm!: FormGroup;

  galleryFiles: WritableSignal<File[]> = signal<File[]>([]);

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.initGiftCardForm();
    this.initGalleryFiles();
  }

  onSubmit() {
    console.log(this.giftCardForm.value);
  }

  private initGalleryFiles() {
    createFileByPath('./assets/images/gift-card/default.png').subscribe({
      next: (file) => {
        this.galleryFiles.update((files) => [file, ...files]);
        this.giftCardForm.patchValue({ image: file });
      }
    });
  }

  private initGiftCardForm() {
    this.giftCardForm = this.formBuilder.group({
      image: [null, [Validators.required]],

      recipientName: [null, [Validators.required]],
      recipientEmail: [null, [Validators.required, Validators.email]],

      senderName: [null, [Validators.required]],
      senderMessage: [null, [Validators.required]],

      amount: [null, [Validators.required]]
    });
  }
}
